import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const ActionsContainer = styled(Box)({
  display: 'flex',
  gap: '10px',
  flexDirection: 'row',
});

const BaseButton = styled(Button)({
  width: '99%',
  minWidth: '40px',
  color: '#ffffff',
  borderRadius: '5px',
  border: '1px solid transparent',
  alignSelf: 'center',
  boxShadow: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '40px',
  backgroundSize: '30px 30px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  '& .MuiButton-label': {
    display: 'none',
  },
});

export const PdfButton = styled(BaseButton)(() => ({
  backgroundColor: 'var(--secondary-main)',
  backgroundImage: 'url("/Icons/pdf-icon.svg")',
  '&:hover': {
    backgroundColor: 'var(--secondary-light)',
  },
}));

export const DocxButton = styled(BaseButton)({
  backgroundColor: '#4B8BF4',
  borderColor: '#4B8BF4',
  backgroundImage: 'url("/Icons/docx-icon.svg")',
  '&:hover': {
    backgroundColor: '#3b6bbf',
  },
});

export const WorkflowButton = styled(BaseButton)({
  backgroundColor: '#384f9a',
  borderColor: '#384f9a',
  backgroundImage: 'url("/Icons/workflow-icon.svg")',
  '&:hover': {
    backgroundColor: '#212f5d',
  },
}); 